import React, { Component } from "react";
import Flexbox from 'flexbox-react';

const shopListItemName = {
    "fontFamily": "graphikMedium",
	"width": "99%",
    "fontSize": "1.3em",
    "marginRight": "1%",
    "textOverflow": "ellipsis",
};

export default class ShopListItemBodyNameOnly extends Component {
    render() {
        return (
           <Flexbox height="auto" flexGrow={1} flexDirection="column" justifyContent="center">
               <Flexbox style={shopListItemName}>
                   {this.props.shop.name.length < 48 ? this.props.shop.name
                       : this.props.shop.name.slice(0, 45) + '...'}
               </Flexbox>
           </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/shop_list_item/shop_list_item_body_name_only.jsx